import { Injectable } from '@angular/core';
import { forkJoin, Observable, of } from 'rxjs';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { UserService } from './user.service';
import { switchMap } from 'rxjs/operators';
import { TranslateLoader } from '@ngx-translate/core';

@Injectable({
  providedIn: 'root'
})
export class LabelService {
  constructor(private http: HttpClient, private userService: UserService) {}

  public getLabels(lang: string): Observable<any> {
    if (this.userService.isLoggedIn()) {
      return forkJoin([this.getPrivateLabels(), this.getPublicLabels(lang)]).pipe(
        switchMap(results => of({ ...results[0], ...results[1] }))
      );
    }
    return this.getPublicLabels(lang);
  }

  public getPublicLabels(lang: string): Observable<any> {
    const queryParams = new HttpParams().set('language', lang);
    return this.http.get(environment.serverBaseUrl + 'label/public', { params: queryParams });
  }

  public getPrivateLabels(): Observable<any> {
    return this.http.get(environment.serverBaseUrl + 'label');
  }
}

export class CommifyTranslationLoader implements TranslateLoader {
  constructor(private labelService: LabelService) {}

  getTranslation(lang: string): Observable<any> {
    return this.labelService.getLabels(lang);
  }
}

export function CommifyLabelLoaderFactory(labelsService: LabelService) {
  return new CommifyTranslationLoader(labelsService);
}
